export const EVENT_TYPE_WALLET_ACTIVITY = 'EVENT_TYPE_WALLET_ACTIVITY';

export const SUPPORTED_EVENT_TYPES = [
  'EVENT_TYPE_ERC20_TRANSFER',
  'EVENT_TYPE_ERC721_TRANSFER',
  EVENT_TYPE_WALLET_ACTIVITY,
];

export const WEBHOOK_STATUS = {
  active: 'WEBHOOK_STATUS_ACTIVE',
  deactivated: 'WEBHOOK_STATUS_DEACTIVATED',
};
